import spotifyImg from '../assets/spotify.png';
import volvoImg from '../assets/volvo.png';
import styled from 'styled-components';
import Title from './HeaderTitle';

const Customer = styled.img`
    height: 3.125rem;
    margin: 1.25rem;
`;

export function Customers() {
  return <div className="customers">
    <Title>Customers</Title>
    <div style={{ margin: '0px;'}}>
      <Customer src={spotifyImg} alt="Spotify" />
      <Customer src={volvoImg} alt="Volvo Cars" />
    </div>
  </div>;
}
